import React from 'react';

const selectStyle = {
    padding: '0.3rem 2rem 0.3rem 0.6rem',
    fontSize: '0.85rem',
    width: 'auto',
    minWidth: '150px',
    background: '#FFFFFF',
    color: '#001f3d',
    borderRadius: '999px',
    border: 'none',
    cursor: 'pointer',
    margin: 0
};

export default function ProjectHeaderControl({ projects, activeProjectId, onSwitch }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--header-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Project</span>
            <select
                value={activeProjectId || ''}
                onChange={(e) => onSwitch(e.target.value)}
                className="input-field"
                style={selectStyle}
                aria-label="Active project"
            >
                <option value="">-- No Active Project --</option>
                {(projects || []).map(p => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                ))}
            </select>
        </div>
    );
}
